module.exports = __webpack_public_path__ + "fonts/Lato-400-latin6.e1b3b59.woff2";